import React from 'react';
import { useAuthState } from 'ra-core';
import { useRedirect } from 'react-admin';
import { useQueryClient } from 'react-query';

type OnlyWithNoAuthProps = any;

const OnlyWithNoAuth = (props: OnlyWithNoAuthProps) => {
  const { isLoading, authenticated } = useAuthState();
  const redirect = useRedirect();
  const queryClient = useQueryClient();

  if (!isLoading && authenticated) {
    queryClient.invalidateQueries('auth');
    redirect('/');
    return null;
  }
  return props.children;
};

export default OnlyWithNoAuth;
